import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

/**
 * Supabase client instance.
 * If env vars are empty, the client is created but non-functional.
 * Use isSupabaseConfigured() to check before making calls.
 */
export const supabase: SupabaseClient = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

/**
 * Returns true if Supabase environment variables are set.
 * When false, the app runs in mock/local mode.
 */
export const isSupabaseConfigured = (): boolean =>
  !!(supabaseUrl && supabaseAnonKey);
